// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__3_01f","OrderButton":"BuildControls__OrderButton__myBwT","enable":"BuildControls__enable__3jYIq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 154
// module chunks = 3